import { render, staticRenderFns } from "./taskhistory.vue?vue&type=template&id=557b3c66&scoped=true&"
import script from "./taskhistory.vue?vue&type=script&lang=js&"
export * from "./taskhistory.vue?vue&type=script&lang=js&"
import style0 from "./taskhistory.vue?vue&type=style&index=0&id=557b3c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557b3c66",
  null
  
)

export default component.exports